import React from 'react';
import SubscriptionsTable from '@/components/Tables/SubscriptionsTable';
import StaticLayoutInner from '@/layouts/StaticLayoutInner';
import TableLayout from '@/layouts/TableLayout';

function Subscriptions() {
  return (
    <StaticLayoutInner>
      <TableLayout
        title="Subscriptions"
        description="Here are project subscriptions"
      >
        <SubscriptionsTable pageSize={20} />
      </TableLayout>
    </StaticLayoutInner>
  );
}

export default Subscriptions;
